import {ActionButton as $b41412308e87d8d9$export$cfc7921d29ef7b80} from "../button/ActionButton.mjs";
import {ActionGroup as $e4f8d481fcca6617$export$c21a5597f732a168} from "../actiongroup/ActionGroup.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import $dytRF$intlStringsmjs from "./intlStrings.mjs";
import {OpenTransition as $b431375c58b93f60$export$b847a40ee92eff38} from "../overlays/OpenTransition.mjs";
import "./actionbar.css";
import $dytRF$actionbar_cssmjs from "./actionbar_css.mjs";
import {Text as $f8cc90fea9436c19$export$5f1af8db9871e1d6} from "../text/Text.mjs";
import {useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {announce as $dytRF$announce} from "react-aria/private/live-announcer/LiveAnnouncer";
import $dytRF$spectrumiconsuiCrossLarge from "@spectrum-icons/ui/CrossLarge";
import {filterDOMProps as $dytRF$filterDOMProps} from "react-aria/filterDOMProps";
import {FocusScope as $dytRF$FocusScope} from "react-aria/FocusScope";
import $dytRF$react, {useState as $dytRF$useState, useRef as $dytRF$useRef, useEffect as $dytRF$useEffect} from "react";
import {useKeyboard as $dytRF$useKeyboard} from "react-aria/useKeyboard";
import {useLocalizedStringFormatter as $dytRF$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
















const $7d249c89c790c78f$export$e213cebad6250b4a = /*#__PURE__*/ (0, $dytRF$react).forwardRef(function ActionBar(props, ref) {
    let isOpen = props.selectedItemCount !== 0;
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    return /*#__PURE__*/ (0, $dytRF$react).createElement((0, $b431375c58b93f60$export$b847a40ee92eff38), {
        nodeRef: domRef,
        in: isOpen,
        mountOnEnter: true,
        unmountOnExit: true
    }, /*#__PURE__*/ (0, $dytRF$react).createElement($7d249c89c790c78f$var$ActionBarInnerWithRef, {
        ...props,
        ref: domRef
    }));
});
function $7d249c89c790c78f$var$ActionBarInner(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    let { children: children, isEmphasized: isEmphasized, onAction: onAction, onClearSelection: onClearSelection, selectedItemCount: selectedItemCount, isOpen: isOpen, buttonLabelBehavior: buttonLabelBehavior = 'collapse', items: items, disabledKeys: disabledKeys } = props;
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(props);
    let stringFormatter = (0, $dytRF$useLocalizedStringFormatter)((0, ($parcel$interopDefault($dytRF$intlStringsmjs))), '@react-spectrum/actionbar');
    // Store the last count greater than zero in a ref so that we can retain it while rendering the fade-out animation.
    let [lastCount, setLastCount] = (0, $dytRF$useState)(selectedItemCount);
    if ((selectedItemCount === 'all' || selectedItemCount > 0) && selectedItemCount !== lastCount) setLastCount(selectedItemCount);
    let { keyboardProps: keyboardProps } = (0, $dytRF$useKeyboard)({
        onKeyDown (e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                onClearSelection();
            }
        }
    });
    // Announce "actions available" on mount.
    let isInitial = (0, $dytRF$useRef)(true);
    (0, $dytRF$useEffect)(()=>{
        if (isInitial.current) {
            isInitial.current = false;
            (0, $dytRF$announce)(stringFormatter.format('actionsAvailable'));
        }
    }, [
        stringFormatter
    ]);
    return /*#__PURE__*/ (0, $dytRF$react).createElement((0, $dytRF$FocusScope), {
        restoreFocus: true
    }, /*#__PURE__*/ (0, $dytRF$react).createElement("div", {
        ...(0, $dytRF$filterDOMProps)(props),
        ...styleProps,
        ...keyboardProps,
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dytRF$actionbar_cssmjs))), 'react-spectrum-ActionBar', {
            'react-spectrum-ActionBar--emphasized': isEmphasized,
            'is-open': isOpen
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $dytRF$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dytRF$actionbar_cssmjs))), 'react-spectrum-ActionBar-bar')
    }, /*#__PURE__*/ (0, $dytRF$react).createElement((0, $e4f8d481fcca6617$export$c21a5597f732a168), {
        items: items,
        "aria-label": stringFormatter.format('actions'),
        isQuiet: true,
        staticColor: isEmphasized ? 'white' : undefined,
        overflowMode: "collapse",
        buttonLabelBehavior: buttonLabelBehavior,
        onAction: onAction,
        disabledKeys: disabledKeys,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dytRF$actionbar_cssmjs))), 'react-spectrum-ActionBar-actionGroup')
    }, children), /*#__PURE__*/ (0, $dytRF$react).createElement((0, $b41412308e87d8d9$export$cfc7921d29ef7b80), {
        gridArea: (0, ($parcel$interopDefault($dytRF$actionbar_cssmjs))).clear,
        "aria-label": stringFormatter.format('clearSelection'),
        onPress: ()=>onClearSelection(),
        isQuiet: true,
        staticColor: isEmphasized ? 'white' : undefined
    }, /*#__PURE__*/ (0, $dytRF$react).createElement((0, $dytRF$spectrumiconsuiCrossLarge), null)), /*#__PURE__*/ (0, $dytRF$react).createElement((0, $f8cc90fea9436c19$export$5f1af8db9871e1d6), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dytRF$actionbar_cssmjs))), 'react-spectrum-ActionBar-selectedCount')
    }, lastCount === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selected', {
        count: lastCount
    })))));
}
const $7d249c89c790c78f$var$ActionBarInnerWithRef = /*#__PURE__*/ (0, $dytRF$react).forwardRef($7d249c89c790c78f$var$ActionBarInner);


export {$7d249c89c790c78f$export$e213cebad6250b4a as ActionBar};
//# sourceMappingURL=ActionBar.mjs.map
